export default __webpack_public_path__ + "1f516dcac177c63a4ff95f37e377a22e.svg";